export default "__VITE_ASSET__BzGLOGgs__"